<template>
	<div :id="id" :class="[
		'hero-box',
		heroBoxClass,
		'align-stretch',
		'container',
	]">
		<div :class="['hero-container-images', 'md-width-50', 'text-align-center']">
			<img v-if="hasBannerUrl" class="max-w-images-banner" :src="bannerImageSrc" :alt="imageAlt" width="300" />
			<img v-else class="max-w-images" :src="imageSrc" :alt="imageAlt" width="300" />
		</div>
		<div :class="verticalRulerClass"></div>
		<div :class="['hero-text-product', hasBannerText ? 'mr-3' : '']">
			<div v-if="hasBannerText" v-html="bannerText"></div>
			<div v-else>
				<h1 class="hero-box-title">{{ title }}</h1>
				<p>{{ description }}</p>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'HeroBox',
	props: {
		type: {
			type: String,
			required: true,
		},
		banner: {
			type: Object,
			default: () => ({ banner_text: '', banner_url: '' }),
		},
	},
	computed: {
		id() {
			return 'hero-box-product';
		},
		heroBoxClass() {
			return {
				nominale: 'rounded-blue',
				storica: 'rounded-green',
				'ruote-classiche': 'rounded-black',
				'live-market': 'rounded-red',
			}[this.type];
		},
		imageSrc() {
			return {
				nominale: '../../../images/project-img/Logo_quotazioni.png',
				storica: '../../../images/project-img/quotazioni-storica-logo.png',
				'ruote-classiche': '../../../images/project-img/quotazioni-ruoteclassiche-logo.png',
				'live-market': '../../../images/project-img/quotazioni-livemarket-logo.png',
			}[this.type];
		},
		imageAlt() {
			return {
				nominale: 'Logo Quotazioni Nominale Quattroruote',
				storica: 'Logo Quotazioni Storica Quattroruote',
				'ruote-classiche': 'Logo Quotazioni Ruote Classiche Quattroruote',
				'live-market': 'Logo Report Live Market Dueruote',
			}[this.type];
		},
		verticalRulerClass() {
			return {
				nominale: 'vertical-blue-ruler',
				storica: 'vertical-green-ruler',
				'ruote-classiche': 'vertical-black-ruler',
				'live-market': 'vertical-red-ruler',
			}[this.type];
		},
		title() {
			return {
				nominale: 'SCOPRI QUANTO VALGONO LA TUA MOTO O IL TUO SCOOTER!',
				storica: 'Richiedi una Quotazione Storica a 23,99€',
				'ruote-classiche': 'Scopri quanto vale la tua moto classica!',
				'live-market': 'SCOPRI IL REPORT LIVE MARKET DELLA TUA MOTO!',
			}[this.type];
		},
		description() {
			return {
				nominale:
					'Ricevi a soli 2,99€ la Quotazione Nominale per vendere, comprare e assicurare il tuo veicolo. Le Quotazioni Dueruote sono il risultato delle più aggiornate tecniche di analisi statistica e di accurate rilevazioni di mercato.',
				storica:
					'Acquista la Quotazione di una moto o di uno scooter ad una specifica data nel passato. La Quotazione Storica è utile se devi richiedere un risarcimento per un danno o un furto avvenuto mesi o anni fa.',
				'ruote-classiche':
					'Ricevi a soli 5,99€ la Quotazione Ruote Classiche. Le Quotazioni Dueruote sono il risultato delle più aggiornate tecniche di analisi statistica e di accurate rilevazioni di mercato.',
				'live-market':
					'Ricevi il Report Live Market: una panoramica aggiornata del mercato delle moto usate, con prezzo di mercato, geolocalizzazione degli annunci e posizionamento del tuo veicolo.',
			}[this.type];
		},
		bannerData() {
			return this.banner && this.banner.banner ? this.banner.banner : this.banner;
		},
		hasBannerUrl() {
			return (
				this.bannerData && this.bannerData.banner_url && this.bannerData.banner_url.trim() !== ''
			);
		},
		bannerImageSrc() {
			return this.hasBannerUrl ? '/storage/' + this.bannerData.banner_url : this.imageSrc;
		},
		// Verifica se è presente un banner_text che non sia vuoto o solo "<p><br></p>"
		hasBannerText() {
			return (
				this.bannerData &&
				this.bannerData.banner_text &&
				this.bannerData.banner_text.trim() !== '' &&
				this.bannerData.banner_text.trim() !== '<p><br></p>'
			);
		},
		bannerText() {
			return this.hasBannerText ? this.bannerData.banner_text : '';
		},
	},
};
</script>

<style scoped>
.hero-box-title {
	font-size: 20px;
	font-weight: 700;
	line-height: 35px;
	margin-bottom: 10px;

	@media screen and (max-width: 768px) {
		font-size: 26px;
	}
}

.border-radius-10 {
	border-radius: 10px;
}

.p-0 {
	padding: 0;
}

.justify-content-between {
	justify-content: space-between !important;
}

.mr-3 {
	margin-right: 3rem;
}

.max-w-images-banner {
	max-width: 100%;
}
</style>



// WEBPACK FOOTER //
// resources/js/app/components/HeroBox.vue